import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { apiRoutesUrls } from "Api/ApiNames";
import { LoaderPage } from "../../Components/LoaderPage/loaderPage";
import translation from "../../Components/Helpers/translation";
import { toUrlSlug } from "../../Components/Helpers/toUrlSlug";
import styles from "../ArchiveShow/ArchivesShow.module.css";
import Footer from "../Footer/Footer";

function formatAuthors(authors) {
    if (!authors || !authors.length) {
        return "";
    }
    return authors
        .map((a) => [a.first_name, a.last_name].filter(Boolean).join(" "))
        .filter(Boolean)
        .join(", ");
}

const ArticleShow = () => {
    const [data, setData] = useState(null);
    const { lang, id } = useParams();
    const history = useHistory();
    const location = useLocation();
    const articleId = parseInt(id, 10);

    useEffect(() => {
        if (!data?.title) {
            return;
        }

        const pathParts = location.pathname.split("/");
        const currentSegment = pathParts[3];
        const expectedSegment = `${articleId}-${toUrlSlug(data.title)}`;

        if (currentSegment !== expectedSegment) {
            pathParts[3] = expectedSegment;
            history.replace(`${pathParts.join("/")}${location.search}${location.hash}`);
        }
    }, [articleId, data, history, location.hash, location.pathname, location.search]);

    useEffect(() => {
        if (Number.isNaN(articleId)) {
            setData({});
            return;
        }

        setData(null);

        const body = new URLSearchParams();
        body.append("data", JSON.stringify(apiRoutesUrls.articlesGetByIdPayload));

        fetch(`${apiRoutesUrls.main}articles/get_article_by_id/${articleId}?lang=${lang}`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString(),
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(String(res.status));
                }
                return res.json();
            })
            .then((json) => {
                setData(json && json.id ? json : {});
            })
            .catch(() => {
                setData({});
            });
    }, [articleId, lang]);

    const authorsLine = data ? formatAuthors(data.authors) : "";

    return (
        <>
            <Helmet>
                <title>
                    {translation.helmet.articlesTitleDetails}{" "}
                    {data?.title ? `«${data.title}»` : ""} - {translation.helmet.main}
                </title>
            </Helmet>
            <LoaderPage data={data} scroll={false} />
            {data && data.id ? (
                <div className={styles.wrapper}>
                    <div className={styles.backgroundTitle}>
                        <h1 className={styles.mainTitle}>{translation.titles.articles}</h1>
                    </div>
                    <div className={styles.container}>
                        <div className={styles.titleWrapper}>
                            <div className={styles.titleSubWrapper}>
                                <h2 className={styles.title}>{data.title}</h2>
                            </div>
                            {authorsLine ? (
                                <div className={styles.subTitle}>
                                    {translation.articles.authorLine}: {authorsLine}
                                </div>
                            ) : null}
                        </div>
                        {data.txt ? (
                            <div
                                className={styles.text}
                                dangerouslySetInnerHTML={{ __html: data.txt }}
                            />
                        ) : null}
                        <div className={styles.buttonWrapper}>
                            <Link
                                to={`/${lang}/artykuly`}
                                className={styles.button}
                                title={translation.articles.backToList}
                                aria-label={translation.articles.backToList}
                            >
                                {translation.articles.backToList}
                            </Link>
                        </div>
                    </div>
                    <Footer />
                </div>
            ) : data ? (
                <div className={styles.wrapper}>
                    <div className={styles.backgroundTitle}>
                        <h1 className={styles.mainTitle}>{translation.titles.articles}</h1>
                    </div>
                    <div className={styles.container}>
                        <p className={styles.text}>{translation.articles.notFound}</p>
                        <div className={styles.buttonWrapper}>
                            <Link
                                to={`/${lang}/artykuly`}
                                className={styles.button}
                                title={translation.articles.backToList}
                                aria-label={translation.articles.backToList}
                            >
                                {translation.articles.backToList}
                            </Link>
                        </div>
                    </div>
                    <Footer />
                </div>
            ) : null}
        </>
    );
};

export default ArticleShow;
